import React from 'react';
import { DEVICES } from '../../constants';
import { useAppConfig } from '../appConfig/AppConfig';

/**
 * Switch between views, based on type and NATIVE_PARAMS
 *
 * @param {object} props
 * @param {array<Element>} children
 * @param {string} type
 */
export function DeviceViewSwitcherComponent({ children, flat, type }) {
  const { isWeb } = useAppConfig();
  const device = isWeb ? DEVICES.WEB : DEVICES.NATIVE;

  // early quit
  if (device !== type && !flat) {
    return null;
  }

  let View = null;
  const childrens = React.Children.toArray(children);

  for (let i = 0; i < childrens.length; i += 1) {
    const elem = childrens[i];
    const { View: InnerView, type } = elem.props;

    if (!flat) {
      if (InnerView !== null) {
        View = elem;
        break;
      }
    }

    if (flat && type === device) {
      View = elem;
    }
  }

  return View || null;
}
export default DeviceViewSwitcherComponent;
